import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useSetTsdImmediateResponse = () => {
  const queryClient = useQueryClient();

  return apiClient.customsSimulator.setTsdImmediateResponse.useMutation({
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['temporary-storages'] });

      toast.success(data.body.message || 'Immediate response configured');
    },
    onError: (error) => {
      showErrorToast(error, 'Error setting TSD immediate response');
    },
  });
};
